import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showError, showSuccess } from "../../toaster/store/slice";
import { ForgotPasswordFormValues } from "../ForgotPasswordPage";
import forgotPasswordPageSlice from "./slice";

type ForgotResponse = ApiResponse<{ success: boolean }>;

function* forgotPasswordPageSaga() {
  yield takeLatest(forgotPasswordPageSlice.actions.sendRequest, handleSend);
}

function* handleSend({ payload }: PayloadAction<ForgotPasswordFormValues>) {
  const response: ForgotResponse = yield call(fetchAPI, "/forgot-password", {
    method: HttpMethod.POST,
    body: JSON.stringify(payload),
  });

  if (response && response.success) {
    yield put(forgotPasswordPageSlice.actions.setRequestSend());

    yield put(showSuccess("Reset link sent. Check your email."));
  } else if (response && response.message === "Account is deleted.") {
    // skip the message
  } else {
    yield put(
      showError("Something went wrong. Please try again or contact support.")
    );
  }

  yield put(forgotPasswordPageSlice.actions.setIsLoading(false));
}

export default forgotPasswordPageSaga;
